import React from "react";
import { Modal, Button, TextBox, IconWarningAlt } from "@veneer/core";

interface TimeBlockedModalProps {
  show: boolean;
  timeRepeat: number;
  onClose: () => void;
  t: (key: string) => string;
  actualCourse: string;
}

export const TimeBlockedModal: React.FC<TimeBlockedModalProps> = ({
  show,
  timeRepeat,
  onClose,
  t,
  actualCourse,
}) => {
  return (
    <Modal
      className="modalTimeFailedCourse"
      align="center"
      show={show}
      onClose={onClose}
      title={actualCourse}
    >
      <IconWarningAlt size={120} />

      <p>
        <b>{t("header.alertTimeFailedCourse")}</b>
      </p>

      <div className="modalTimeTextboxs">
        <TextBox
          className="modalTimeTextbox"
          id="timeBlockedDays"
          label="D"
          value={String(Math.floor(timeRepeat / 86400))}
          readOnly
        />
        <TextBox
          className="modalTimeTextbox"
          id="timeBlockedHours"
          label="H"
          value={String(Math.floor((timeRepeat % 86400) / 3600))}
          readOnly
        />
        <TextBox
          className="modalTimeTextbox"
          id="timeBlockedMinutes"
          label="M"
          value={String(Math.floor(((timeRepeat % 86400) % 3600) / 60))}
          readOnly
        />
        <TextBox
          className="modalTimeTextbox"
          id="timeBlockedSeconds"
          label="S"
          value={String(((timeRepeat % 86400) % 3600) % 60)}
          readOnly
        />
      </div>

      <div className="modalActions">
        <Button appearance="primary" onClick={onClose}>
          {t("header.closebutton")}
        </Button>
      </div>
    </Modal>
  );
};
